export default function() {
	return {
		restrict: 'A',
		link: function ($scope, element, attr) {

			angular.element(element).on('click', function(e){
				if (angular.element(element).hasClass('is-trigger')) {
					let childRef = angular.element(element).attr('data-child-ref');
					angular.element(document.querySelector('[data-parent-ref="'+childRef+'"]')).toggleClass('is-open');
					angular.element(element).toggleClass('js-btn-menu-toggler--open').parent().parent().toggleClass('nav-main__item--open');
				}
			});
			
		}
	};	
};
